(() => {
  if (window.__SQ_EXPANDED_COLOR_BELT__) return;
  window.__SQ_EXPANDED_COLOR_BELT__ = true;

  const MODAL = '[data-lcs-favorite-expanded]';
  const ROWS = [
    '.lcs-favorite-expanded__selectors .pick-quick-option__values',
    '.lcs-favorite-expanded__selectors .pick-quick-option__values--color',
    '.lcs-favorite-expanded__selectors .pick-quick-option__values--visual',
    '.lcs-favorite-expanded__selectors .pick-quick-option__values--size'
  ].join(',');
  const OLD_CONTROLS = '.sq-expanded-color-belt__controls';
  const OVERFLOW_TOLERANCE = 3;

  const boundRows = new WeakSet();
  const boundModals = new WeakSet();
  const resizeObservers = new WeakMap();
  const scheduledModals = new WeakSet();

  const nextLayout = (callback) => {
    requestAnimationFrame(() => requestAnimationFrame(callback));
  };

  const removeOldControls = (scope) => {
    scope.querySelectorAll?.(OLD_CONTROLS).forEach((control) => control.remove());
  };

  const isVisible = (row) => {
    if (!(row instanceof HTMLElement)) return false;
    const rect = row.getBoundingClientRect();
    return rect.width > 0 && rect.height >= 0;
  };

  const updateRow = (row) => {
    if (!(row instanceof HTMLElement)) return;

    row.classList.add('sq-expanded-option-belt');
    row.classList.remove('sq-expanded-color-belt');

    if (!isVisible(row)) return;

    const overflow = row.scrollWidth > row.clientWidth + OVERFLOW_TOLERANCE;
    row.classList.toggle('sq-expanded-option-belt--scrollable', overflow);
    row.classList.toggle('sq-expanded-option-belt--static', !overflow);
    row.dataset.sqBeltOverflow = overflow ? 'true' : 'false';
    row.setAttribute('aria-roledescription', overflow ? 'horizontal option slider' : 'option list');

    if (!overflow && row.scrollLeft !== 0) {
      row.scrollLeft = 0;
    }
  };

  const bindRow = (row) => {
    if (!(row instanceof HTMLElement)) return;
    updateRow(row);
    if (boundRows.has(row)) return;
    boundRows.add(row);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => updateRow(row));
      observer.observe(row);
      Array.from(row.children).forEach((child) => observer.observe(child));
      resizeObservers.set(row, observer);
    }
  };

  const collectRows = (modal) => {
    const rows = new Set();
    modal.querySelectorAll(ROWS).forEach((row) => rows.add(row));
    return rows;
  };

  const refreshModal = (modal) => {
    if (!(modal instanceof HTMLElement)) return;
    removeOldControls(modal);
    collectRows(modal).forEach(bindRow);
  };

  const scheduleRefresh = (modal) => {
    if (!(modal instanceof HTMLElement) || scheduledModals.has(modal)) return;
    scheduledModals.add(modal);
    nextLayout(() => {
      scheduledModals.delete(modal);
      refreshModal(modal);
    });
  };

  const bindModal = (modal) => {
    if (!(modal instanceof HTMLElement)) return;
    scheduleRefresh(modal);
    if (boundModals.has(modal)) return;
    boundModals.add(modal);

    const observer = new MutationObserver((records) => {
      const relevant = records.some((record) =>
        record.type === 'childList' ||
        (record.type === 'attributes' && record.attributeName === 'hidden')
      );
      if (relevant) scheduleRefresh(modal);
    });

    observer.observe(modal, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden']
    });

    modal.addEventListener('change', () => scheduleRefresh(modal), true);
    modal.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('.pick-quick-option__pill')) {
        scheduleRefresh(modal);
      }
    }, true);
  };

  const initialize = (scope = document) => {
    if (scope instanceof Element && scope.matches(MODAL)) bindModal(scope);
    scope.querySelectorAll?.(MODAL).forEach(bindModal);
  };

  const refreshAll = () => {
    document.querySelectorAll(MODAL).forEach(scheduleRefresh);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  window.addEventListener('resize', refreshAll, { passive: true });
  window.addEventListener('orientationchange', refreshAll, { passive: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
